<template>
  <fragment>{{ formatted }}</fragment>
</template>

<script>
import moment from 'moment'

const dateFormat = 'DD/MM/YYYY';
const dateTimeFormat = 'DD/MM/YYYY HH:mm';

export default {
  props: {
    date: {
      type: String
    },
    format: {
      type: String,
      default: ''
    },
    time: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formatted() {

      if (!this.date) {
        return '-'
      }

      if (this.format !== '') {
        return moment(this.date).format(this.format)
      }

      const format = this.time? dateTimeFormat : dateFormat;

      return moment(this.date).format(format)
    }
  },
};
</script>